import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

const handleExport = (data, fileType, name) => {
  const ws = XLSX.utils.json_to_sheet(data)
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const excelBuffer = XLSX.write(wb, { bookType: fileType, type: 'array' })
  const dataBlob = new Blob([excelBuffer], {
    type:
      fileType === 'csv'
        ? 'text/csv'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  })
  FileSaver.saveAs(dataBlob, `${name}.${fileType}`)
}

export default handleExport
